function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* istanbul ignore file */
import { actions, makePropGetter, ensurePluginOrder, useMountedLayoutEffect, useGetLatest } from '../publicUtils';
import { flattenColumns, getFirstDefined } from '../utils'; // Actions

actions.resetPivot = 'resetPivot';
actions.togglePivot = 'togglePivot';
export var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
  hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
  hooks.stateReducers.push(reducer);
  hooks.useInstanceAfterData.push(useInstanceAfterData);
  hooks.allColumns.push(allColumns);
  hooks.accessValue.push(accessValue);
  hooks.materializedColumns.push(materializedColumns);
  hooks.materializedColumnsDeps.push(materializedColumnsDeps);
  hooks.visibleColumns.push(visibleColumns);
  hooks.visibleColumnsDeps.push(visibleColumnsDeps);
  hooks.useInstance.push(useInstance);
  hooks.prepareRow.push(prepareRow);
};
_UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
var defaultPivotColumns = [];

var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
  var header = _ref.header;
  return [props, {
    onClick: header.canPivot ? function (e) {
      e.persist();
      header.togglePivot();
    } : undefined,
    style: {
      cursor: header.canPivot ? 'pointer' : undefined
    },
    title: 'Toggle Pivot'
  }];
}; // Reducer


function reducer(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _objectSpread({
      pivotColumns: defaultPivotColumns
    }, state);
  }

  if (action.type === actions.resetPivot) {
    return _objectSpread(_objectSpread({}, state), {}, {
      pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
    });
  }

  if (action.type === actions.togglePivot) {
    var columnId = action.columnId,
        setPivot = action.value;
    var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);

    if (resolvedPivot) {
      return _objectSpread(_objectSpread({}, state), {}, {
        pivotColumns: [].concat(_toConsumableArray(state.pivotColumns), [columnId])
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      pivotColumns: state.pivotColumns.filter(function (d) {
        return d !== columnId;
      })
    });
  }
}

function useInstanceAfterData(instance) {
  instance.allColumns.forEach(function (column) {
    column.isPivotSource = instance.state.pivotColumns.includes(column.id);
  });
}

function allColumns(columns, _ref2) {
  var instance = _ref2.instance;
  columns.forEach(function (column) {
    column.isPivotSource = instance.state.pivotColumns.includes(column.id);
    column.uniqueValues = new Set();
  });
  return columns;
}

function accessValue(value, _ref3) {
  var column = _ref3.column;

  if (column.uniqueValues && typeof value !== 'undefined') {
    column.uniqueValues.add(value);
  }

  return value;
}

function materializedColumns(materialized, _ref4) {
  var instance = _ref4.instance;
  var allColumns = instance.allColumns,
      state = instance.state;

  if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
    return materialized;
  }

  var pivotColumns = state.pivotColumns.map(function (id) {
    return allColumns.find(function (d) {
      return d.id === id;
    });
  }).filter(Boolean);
  var sourceColumns = allColumns.filter(function (d) {
    return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
  });

  var buildPivotColumns = function buildPivotColumns() {
    var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var parent = arguments.length > 1 ? arguments[1] : undefined;
    var pivotFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var pivotColumn = pivotColumns[depth];

    if (!pivotColumn) {
      return sourceColumns.map(function (sourceColumn) {
        // TODO: We could offer support here for renesting pivoted
        // columns inside copies of their header groups. For now,
        // that seems like it would be (1) overkill on nesting, considering
        // you already get nesting for every pivot level and (2)
        // really hard. :)
        return _objectSpread(_objectSpread({}, sourceColumn), {}, {
          canPivot: false,
          isPivoted: true,
          parent: parent,
          depth: depth,
          id: "".concat(parent ? "".concat(parent.id, ".").concat(sourceColumn.id) : sourceColumn.id),
          accessor: function accessor(originalRow, i, row) {
            if (pivotFilters.every(function (filter) {
              return filter(row);
            })) {
              return row.values[sourceColumn.id];
            }
          }
        });
      });
    }

    var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
    return uniqueValues.map(function (uniqueValue) {
      var columnGroup = _objectSpread(_objectSpread({}, pivotColumn), {}, {
        Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? "".concat(pivotColumn.Header, ": ").concat(uniqueValue) : uniqueValue,
        isPivotGroup: true,
        parent: parent,
        depth: depth,
        id: parent ? "".concat(parent.id, ".").concat(pivotColumn.id, ".").concat(uniqueValue) : "".concat(pivotColumn.id, ".").concat(uniqueValue),
        pivotValue: uniqueValue
      });

      columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(_toConsumableArray(pivotFilters), [function (row) {
        return row.values[pivotColumn.id] === uniqueValue;
      }]));
      return columnGroup;
    });
  };

  var newMaterialized = flattenColumns(buildPivotColumns());
  return [].concat(_toConsumableArray(materialized), _toConsumableArray(newMaterialized));
}

function materializedColumnsDeps(deps, _ref5) {
  var _ref5$instance$state = _ref5.instance.state,
      pivotColumns = _ref5$instance$state.pivotColumns,
      groupBy = _ref5$instance$state.groupBy;
  return [].concat(_toConsumableArray(deps), [pivotColumns, groupBy]);
}

function visibleColumns(visibleColumns, _ref6) {
  var state = _ref6.instance.state;
  visibleColumns = visibleColumns.filter(function (d) {
    return !d.isPivotSource;
  });

  if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
    visibleColumns = visibleColumns.filter(function (column) {
      return column.isGrouped || column.isPivoted;
    });
  }

  return visibleColumns;
}

function visibleColumnsDeps(deps, _ref7) {
  var instance = _ref7.instance;
  return [].concat(_toConsumableArray(deps), [instance.state.pivotColumns, instance.state.groupBy]);
}

function useInstance(instance) {
  var columns = instance.columns,
      allColumns = instance.allColumns,
      flatHeaders = instance.flatHeaders,
      getHooks = instance.getHooks,
      plugins = instance.plugins,
      dispatch = instance.dispatch,
      _instance$autoResetPi = instance.autoResetPivot,
      autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
      manaulPivot = instance.manaulPivot,
      disablePivot = instance.disablePivot,
      defaultCanPivot = instance.defaultCanPivot;
  ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
  var getInstance = useGetLatest(instance);
  allColumns.forEach(function (column) {
    var accessor = column.accessor,
        defaultColumnPivot = column.defaultPivot,
        columnDisablePivot = column.disablePivot;
    column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);

    if (column.canPivot) {
      column.togglePivot = function () {
        return instance.togglePivot(column.id);
      };
    }

    column.Aggregated = column.Aggregated || column.Cell;
  });

  var togglePivot = function togglePivot(columnId, value) {
    dispatch({
      type: actions.togglePivot,
      columnId: columnId,
      value: value
    });
  };

  flatHeaders.forEach(function (header) {
    header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
      instance: getInstance(),
      header: header
    });
  });
  var getAutoResetPivot = useGetLatest(autoResetPivot);
  useMountedLayoutEffect(function () {
    if (getAutoResetPivot()) {
      dispatch({
        type: actions.resetPivot
      });
    }
  }, [dispatch, manaulPivot ? null : columns]);
  Object.assign(instance, {
    togglePivot: togglePivot
  });
}

function prepareRow(row) {
  row.allCells.forEach(function (cell) {
    // Grouped cells are in the pivotColumns and the pivot cell for the row
    cell.isPivoted = cell.column.isPivoted;
  });
}